// "hace 3 horas", "hace 2 días"… para fechas pasadas; '' si no hay fecha.
export function haceCuanto(fecha) {
  if (!fecha) return '';
  const seg = Math.floor((Date.now() - new Date(fecha).getTime()) / 1000);
  if (seg < 60) return 'hace instantes';
  const min = Math.floor(seg / 60);
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.floor(h / 24);
  if (d < 31) return `hace ${d} día${d === 1 ? '' : 's'}`;
  const m = Math.floor(d / 30.44);
  if (m < 12) return `hace ${m} mes${m === 1 ? '' : 'es'}`;
  const a = Math.floor(m / 12);
  return `hace ${a} año${a === 1 ? '' : 's'}`;
}

export const fechaHora = (fecha) => (fecha
  ? new Date(fecha).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  : '—');

export const soloFecha = (fecha) => (fecha ? new Date(fecha).toLocaleDateString('es-CL') : '—');
